import React from 'react';
import { Box, Typography, IconButton, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Grid, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import BoltPatternDiagram from './BoltPatternDiagram';

export default function FlangeSpecifications() {
    const navigate = useNavigate();

    // ANSI 150# Flanges
    const ansi150Data = [
        { nominal: '1/2', quantity: 4, diameter: '1/2', min: 40, max: 50 },
        { nominal: '3/4', quantity: 4, diameter: '1/2', min: 40, max: 50 },
        { nominal: '1', quantity: 4, diameter: '1/2', min: 40, max: 50 },
        { nominal: '1 1/2', quantity: 4, diameter: '1/2', min: 40, max: 50 },
        { nominal: '2', quantity: 4, diameter: '5/8', min: 80, max: 90 },
        { nominal: '2 1/2', quantity: 4, diameter: '5/8', min: 80, max: 90 },
        { nominal: '3', quantity: 4, diameter: '5/8', min: 80, max: 90 },
        { nominal: '3 1/2', quantity: 8, diameter: '5/8', min: 80, max: 90 },
        { nominal: '4', quantity: 8, diameter: '5/8', min: 100, max: 110 },
        { nominal: '5', quantity: 8, diameter: '3/4', min: 120, max: 130 },
        { nominal: '6', quantity: 8, diameter: '3/4', min: 130, max: 150 },
        { nominal: '8', quantity: 8, diameter: '3/4', min: 130, max: 150 },
        { nominal: '10', quantity: 12, diameter: '7/8', min: 215, max: 230 },
        { nominal: '12', quantity: 12, diameter: '7/8', min: 220, max: 230 },
        { nominal: '14', quantity: 12, diameter: '1', min: 320, max: 340 },
        { nominal: '16', quantity: 16, diameter: '1', min: 320, max: 340 },
        { nominal: '18', quantity: 16, diameter: '1 1/8', min: 450, max: 470 },
        { nominal: '20', quantity: 20, diameter: '1 1/8', min: 450, max: 470 },
        { nominal: '22', quantity: 20, diameter: '1 1/8', min: 460, max: 480 },
        { nominal: '24', quantity: 20, diameter: '1 1/4', min: 650, max: 670 },
        { nominal: '26', quantity: 24, diameter: '1 1/4', min: 650, max: 670 },
        { nominal: '28', quantity: 28, diameter: '1 1/4', min: 650, max: 670 },
        { nominal: '30', quantity: 28, diameter: '1 1/4', min: 650, max: 670 },
        { nominal: '32', quantity: 28, diameter: '1 1/2', min: 1000, max: 1075 },
        { nominal: '34', quantity: 32, diameter: '1 1/2', min: 1000, max: 1075 },
        { nominal: '36', quantity: 32, diameter: '1 1/2', min: 1100, max: 1180 },
        { nominal: '38', quantity: 32, diameter: '1 1/2', min: 1100, max: 1180 },
        { nominal: '40', quantity: 36, diameter: '1 1/2', min: 1100, max: 1180 },
        { nominal: '42', quantity: 36, diameter: '1 1/2', min: 1150, max: 1200 }
    ];

    // ANSI 300# Flanges
    const ansi300Data = [
        { nominal: '1/2', quantity: 4, diameter: '1/2', min: 80, max: 90 },
        { nominal: '3/4', quantity: 4, diameter: '5/8', min: 110, max: 120 },
        { nominal: '1', quantity: 4, diameter: '5/8', min: 110, max: 120 },
        { nominal: '1 1/2', quantity: 4, diameter: '3/4', min: 110, max: 120 },
        { nominal: '2', quantity: 8, diameter: '5/8', min: 110, max: 120 },
        { nominal: '2 1/2', quantity: 8, diameter: '3/4', min: 150, max: 170 },
        { nominal: '3', quantity: 8, diameter: '3/4', min: 150, max: 170 },
        { nominal: '3 1/2', quantity: 8, diameter: '3/4', min: 150, max: 170 },
        { nominal: '4', quantity: 8, diameter: '3/4', min: 180, max: 200 },
        { nominal: '5', quantity: 8, diameter: '3/4', min: 180, max: 200 },
        { nominal: '6', quantity: 12, diameter: '7/8', min: 170, max: 190 },
        { nominal: '8', quantity: 12, diameter: '1', min: 265, max: 275 },
        { nominal: '10', quantity: 16, diameter: '1 1/8', min: 320, max: 350 },
        { nominal: '12', quantity: 16, diameter: '1 1/8', min: 460, max: 470 },
        { nominal: '14', quantity: 20, diameter: '1 1/4', min: 450, max: 470 },
        { nominal: '16', quantity: 20, diameter: '1 1/4', min: 650, max: 670 },
        { nominal: '18', quantity: 24, diameter: '1 1/4', min: 650, max: 670 },
        { nominal: '20', quantity: 24, diameter: '1 1/4', min: 650, max: 670 },
        { nominal: '22', quantity: 24, diameter: '1 1/2', min: 1125, max: 1150 },
        { nominal: '24', quantity: 24, diameter: '1 1/2', min: 1200, max: 1250 },
        { nominal: '26', quantity: 28, diameter: '1 5/8', min: 1400, max: 1450 },
        { nominal: '28', quantity: 28, diameter: '1 5/8', min: 1500, max: 1550 },
        { nominal: '30', quantity: 28, diameter: '1 3/4', min: 1700, max: 1775 },
        { nominal: '32', quantity: 28, diameter: '1 7/8', min: 2000, max: 2075 },
        { nominal: '34', quantity: 28, diameter: '1 7/8', min: 2250, max: 2075 },
        { nominal: '36', quantity: 32, diameter: '2', min: 2300, max: 2380 },
        { nominal: '38', quantity: 32, diameter: '2', min: 2300, max: 2380 },
        { nominal: '40', quantity: 32, diameter: '2', min: 2400, max: 2480 },
        { nominal: '42', quantity: 32, diameter: '2', min: 2400, max: 2480 }
    ];

    // ANSI 600# Flanges
    const ansi600Data = [
        { nominal: '1/2', quantity: 4, diameter: '1/2', min: 80, max: 90 },
        { nominal: '3/4', quantity: 4, diameter: '5/8', min: 110, max: 120 },
        { nominal: '1', quantity: 4, diameter: '5/8', min: 110, max: 120 },
        { nominal: '1 1/2', quantity: 4, diameter: '3/4', min: 110, max: 120 },
        { nominal: '2', quantity: 8, diameter: '5/8', min: 110, max: 120 },
        { nominal: '2 1/2', quantity: 8, diameter: '3/4', min: 150, max: 170 },
        { nominal: '3', quantity: 8, diameter: '3/4', min: 150, max: 170 },
        { nominal: '3 1/2', quantity: 8, diameter: '7/8', min: 200, max: 220 },
        { nominal: '4', quantity: 8, diameter: '7/8', min: 225, max: 240 },
        { nominal: '5', quantity: 8, diameter: '1', min: 350, max: 370 },
        { nominal: '6', quantity: 12, diameter: '1', min: 320, max: 330 },
        { nominal: '8', quantity: 12, diameter: '1 1/8', min: 450, max: 470 },
        { nominal: '10', quantity: 16, diameter: '1 1/4', min: 650, max: 670 },
        { nominal: '12', quantity: 16, diameter: '1 1/4', min: 675, max: 690 },
        { nominal: '14', quantity: 20, diameter: '1 3/8', min: 820, max: 840 },
        { nominal: '16', quantity: 20, diameter: '1 1/2', min: 1125, max: 1145 },
        { nominal: '18', quantity: 24, diameter: '1 5/8', min: 1430, max: 1450 },
        { nominal: '20', quantity: 24, diameter: '1 5/8', min: 1400, max: 1430 },
        { nominal: '22', quantity: 24, diameter: '1 3/4', min: 1775, max: 1800 },
        { nominal: '24', quantity: 24, diameter: '1 7/8', min: 2230, max: 2250 },
        { nominal: '26', quantity: 28, diameter: '1 7/8', min: 2200, max: 2230 },
        { nominal: '28', quantity: 28, diameter: '2', min: 2300, max: 2330 },
        { nominal: '30', quantity: 28, diameter: '2', min: 2360, max: 2380 },
        { nominal: '32', quantity: 28, diameter: '2 1/4', min: 3900, max: 3930 },
        { nominal: '34', quantity: 28, diameter: '2 1/4', min: 3950, max: 3975 },
        { nominal: '36', quantity: 32, diameter: '2 1/2', min: 5500, max: 5530 },
        { nominal: '38', quantity: 32, diameter: '2 1/2', min: 7000, max: 7030 },
        { nominal: '40', quantity: 32, diameter: '2 3/4', min: 7200, max: 7230 },
        { nominal: '42', quantity: 32, diameter: '2 3/4', min: 7400, max: 7430 }
    ];

    // ANSI 900# Flanges
    const ansi900Data = [
        { nominal: '1/2', quantity: 4, diameter: '3/4', min: 95, max: 120 },
        { nominal: '3/4', quantity: 4, diameter: '3/4', min: 95, max: 120 },
        { nominal: '1', quantity: 4, diameter: '3/4', min: 110, max: 120 },
        { nominal: '1 1/2', quantity: 4, diameter: '3/4', min: 110, max: 120 },
        { nominal: '2', quantity: 8, diameter: '3/4', min: 110, max: 120 },
        { nominal: '2 1/2', quantity: 8, diameter: '3/4', min: 150, max: 170 },
        { nominal: '3', quantity: 8, diameter: '3/4', min: 150, max: 170 },
        { nominal: '3 1/2', quantity: 8, diameter: '7/8', min: 200, max: 220 },
        { nominal: '4', quantity: 8, diameter: '7/8', min: 225, max: 240 },
        { nominal: '5', quantity: 8, diameter: '1', min: 350, max: 370 },
        { nominal: '6', quantity: 12, diameter: '1', min: 320, max: 330 },
        { nominal: '8', quantity: 12, diameter: '1 1/8', min: 450, max: 470 },
        { nominal: '10', quantity: 16, diameter: '1 1/4', min: 650, max: 670 },
        { nominal: '12', quantity: 20, diameter: '1 1/4', min: 675, max: 690 },
        { nominal: '14', quantity: 20, diameter: '1 3/8', min: 820, max: 840 },
        { nominal: '16', quantity: 20, diameter: '1 1/2', min: 1125, max: 1145 },
        { nominal: '18', quantity: 20, diameter: '1 5/8', min: 1430, max: 1450 },
        { nominal: '20', quantity: 24, diameter: '1 5/8', min: 1400, max: 1430 },
        { nominal: '22', quantity: 24, diameter: '1 7/8', min: 2230, max: 2250 },
        { nominal: '24', quantity: 24, diameter: '1 7/8', min: 2200, max: 2230 },
        { nominal: '26', quantity: 28, diameter: '2', min: 2300, max: 2330 },
        { nominal: '28', quantity: 28, diameter: '2', min: 2360, max: 2380 },
        { nominal: '30', quantity: 28, diameter: '2', min: 3900, max: 3930 },
        { nominal: '32', quantity: 28, diameter: '2 1/4', min: 3950, max: 3975 },
        { nominal: '34', quantity: 28, diameter: '2 1/4', min: 5500, max: 5530 },
        { nominal: '36', quantity: 28, diameter: '2 1/2', min: 7000, max: 7030 },
        { nominal: '38', quantity: 28, diameter: '2 3/4', min: 7200, max: 7230 },
        { nominal: '40', quantity: 28, diameter: '2 3/4', min: 7400, max: 7430 },
        { nominal: '42', quantity: 28, diameter: '2 3/4', min: 7400, max: 7430 }
    ];

    // ANSI 1500# Flanges
    const ansi1500Data = [
        { nominal: '1/2', quantity: 4, diameter: '3/4', min: 95, max: 120 },
        { nominal: '3/4', quantity: 4, diameter: '3/4', min: 95, max: 120 },
        { nominal: '1', quantity: 4, diameter: '7/8', min: 110, max: 120 },
        { nominal: '1 1/2', quantity: 4, diameter: '1', min: 240, max: 260 },
        { nominal: '2', quantity: 8, diameter: '7/8', min: 170, max: 190 },
        { nominal: '2 1/2', quantity: 8, diameter: '1', min: 240, max: 260 },
        { nominal: '3', quantity: 8, diameter: '7/8', min: 215, max: 235 },
        { nominal: '4', quantity: 8, diameter: '1 1/8', min: 450, max: 470 },
        { nominal: '5', quantity: 8, diameter: '1 1/8', min: 650, max: 670 },
        { nominal: '6', quantity: 12, diameter: '1 1/8', min: 455, max: 475 },
        { nominal: '8', quantity: 12, diameter: '1 3/8', min: 820, max: 840 },
        { nominal: '10', quantity: 16, diameter: '1 3/8', min: 850, max: 870 },
        { nominal: '12', quantity: 20, diameter: '1 3/8', min: 870, max: 890 },
        { nominal: '14', quantity: 20, diameter: '1 1/2', min: 1125, max: 1155 },
        { nominal: '16', quantity: 20, diameter: '1 5/8', min: 1430, max: 1450 },
        { nominal: '18', quantity: 20, diameter: '1 7/8', min: 2230, max: 2250 },
        { nominal: '20', quantity: 20, diameter: '2', min: 2300, max: 2340 },
        { nominal: '24', quantity: 20, diameter: '2 1/2', min: 5500, max: 5550 },
        { nominal: '26', quantity: 20, diameter: '2 3/4', min: 7400, max: 7450 },
        { nominal: '28', quantity: 20, diameter: '3', min: 8400, max: 8450 },
        { nominal: '30', quantity: 20, diameter: '3', min: 9500, max: 9550 },
        { nominal: '32', quantity: 20, diameter: '3 1/4', min: 10500, max: 10550 },
        { nominal: '34', quantity: 20, diameter: '3 1/2', min: 12400, max: 12450 },
        { nominal: '36', quantity: 20, diameter: '3 1/2', min: 13800, max: 13850 }
    ];

    // ANSI 2500# Flanges
    const ansi2500Data = [
        { nominal: '1/2', quantity: 4, diameter: '3/4', min: 95, max: 120 },
        { nominal: '3/4', quantity: 4, diameter: '7/8', min: 170, max: 190 },
        { nominal: '1', quantity: 4, diameter: '1', min: 400, max: 420 },
        { nominal: '1 1/2', quantity: 4, diameter: '1 1/8', min: 400, max: 420 },
        { nominal: '2', quantity: 8, diameter: '1', min: 300, max: 320 },
        { nominal: '2 1/2', quantity: 8, diameter: '1 1/8', min: 400, max: 420 },
        { nominal: '3', quantity: 8, diameter: '1 1/4', min: 600, max: 640 },
        { nominal: '4', quantity: 8, diameter: '1 3/8', min: 650, max: 680 },
        { nominal: '5', quantity: 8, diameter: '1 3/4', min: 1500, max: 1550 },
        { nominal: '6', quantity: 8, diameter: '2', min: 2300, max: 2350 },
        { nominal: '8', quantity: 12, diameter: '2', min: 2400, max: 2450 },
        { nominal: '10', quantity: 12, diameter: '2 1/2', min: 4900, max: 4950 },
        { nominal: '12', quantity: 12, diameter: '2 3/4', min: 7900, max: 7950 }
    ];

    const renderTable = (title, data, hydroPressure, showDiagrams = true) => (
        <Card sx={{ mb: 0, borderRadius: 0 }}>
            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Typography variant="h6" fontWeight="bold" mb={1.5} sx={{ textAlign: 'center', fontSize: '1.1rem' }}>
                    {title}
                </Typography>
                <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e0e0e0' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#1976d2' }}>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: '0.8rem', p: 1, textAlign: 'center' }}>NOMINAL</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: '0.8rem', p: 1, textAlign: 'center' }}>QUANTITY<br/>OF BOLTS</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: '0.8rem', p: 1, textAlign: 'center' }}>BOLT<br/>DIAMETER</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: '0.8rem', p: 1, textAlign: 'center' }}>REC. TORQUE FT. LBS<br/>MIN</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold', fontSize: '0.8rem', p: 1, textAlign: 'center' }}>REC. TORQUE FT. LBS<br/>MAX</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row, index) => (
                                <TableRow key={index} hover>
                                    <TableCell sx={{ p: 1, fontSize: '0.85rem', textAlign: 'center' }}>{row.nominal}</TableCell>
                                    <TableCell sx={{ p: 1, fontSize: '0.85rem', textAlign: 'center' }}>{row.quantity}</TableCell>
                                    <TableCell sx={{ p: 1, fontSize: '0.85rem', textAlign: 'center' }}>{row.diameter}</TableCell>
                                    <TableCell sx={{ p: 1, fontSize: '0.85rem', textAlign: 'center' }}>{row.min}</TableCell>
                                    <TableCell sx={{ p: 1, fontSize: '0.85rem', textAlign: 'center' }}>{row.max}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {hydroPressure && (
                    <Typography variant="body2" fontWeight="bold" mt={1.5} sx={{ textAlign: 'center', fontSize: '0.9rem' }}>
                        HYDRO TEST PRESSURE: {hydroPressure}
                    </Typography>
                )}

                {/* Bolt Diagrams - only for 150#, 300#, 600#, 900#, 1500# */}
                {showDiagrams && (
                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
                        <BoltPatternDiagram numBolts={8} size={200} />
                        <BoltPatternDiagram numBolts={12} size={200} />
                    </Box>
                )}
            </CardContent>
        </Card>
    );

    return (
        <Box sx={{
            position: 'fixed',
            top: '60px',
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            backgroundColor: 'white'
        }}>
            {/* Header */}
            <Box sx={{ backgroundColor: 'white', borderBottom: '1px solid #e0e0e0', p: 1.5, flexShrink: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconButton onClick={() => navigate('/main')} edge="start">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" fontWeight={600}>ANSI Flange Specifications</Typography>
                </Box>
            </Box>

            {/* Content */}
            <Box sx={{ flex: 1, overflow: 'auto', p: 0 }}>
                <Grid container spacing={0}>
                    {/* First row - 150#, 300#, 600# */}
                    <Grid item xs={12} md={4}>
                        {renderTable('ANSI 150# FLANGES', ansi150Data, '285 PSI')}
                    </Grid>
                    <Grid item xs={12} md={4}>
                        {renderTable('ANSI 300# FLANGES', ansi300Data, '1125 PSI')}
                    </Grid>
                    <Grid item xs={12} md={4}>
                        {renderTable('ANSI 600# FLANGES', ansi600Data, '2245 PSI')}
                    </Grid>

                    {/* Second row - 900#, 1500#, 2500# (no bolt diagrams) */}
                    <Grid item xs={12} md={4}>
                        {renderTable('ANSI 900# FLANGE', ansi900Data, '3355 PSI', false)}
                    </Grid>
                    <Grid item xs={12} md={4}>
                        {renderTable('ANSI 1500# FLANGE', ansi1500Data, '5585 PSI', false)}
                    </Grid>
                    <Grid item xs={12} md={4}>
                        {renderTable('ANSI 2500# FLANGE', ansi2500Data, '9280 PSI', false)}
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
